import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
const steps = [{
  n: '01',
  title: 'Connect',
  body: 'Cloud, identity, SaaS, code, domains, external exposure, AI applications, optional internal runner. Guided permissions, clear scope.'
}, {
  n: '02',
  title: 'Model',
  body: 'Periscan builds an AI-driven evidence model of your environment — assets, identities, permissions, code signals, AI applications, remediation history.'
}, {
  n: '03',
  title: 'Validate',
  body: 'Identify realistic paths to compromise. Validate which risks are reachable, exploitable, exposed, misconfigured, or blocked. Controlled and scoped.'
}, {
  n: '04',
  title: 'Prioritize',
  body: 'Rank what matters based on evidence, reachability, privilege, impact, confidence, exploitability, business context, and validation status.'
}, {
  n: '05',
  title: 'Fix',
  body: 'Plain-English remediation, technical steps, owner guidance, ticket-ready action plans.'
}, {
  n: '06',
  title: 'Verify',
  body: 'Re-test the path. Confirm whether the risk is fixed, partially fixed, still exposed, mitigated, inconclusive, or reopened due to drift.'
}, {
  n: '07',
  title: 'Prove',
  body: 'Evidence-backed reports your team can share with customers, auditors, cyber insurers, executives, boards, vCISOs, and MSSP clients.'
}];
export function Workflow() {
  return <section id="workflow" className="relative w-full py-32 border-t border-white/5" data-id="element-1463">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1464">
        <SectionLabel number="07" label="How It Works" className="mb-8" data-id="element-1465" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-1466">
          <div className="lg:col-span-8" data-id="element-1467">
            <SectionHeading size="xl" data-id="element-1468">
              From signal to proof
              <br data-id="element-1469" />
              <span className="text-white/40" data-id="element-1470">in seven steps.</span>
            </SectionHeading>
          </div>
        </div>

        {/* Workflow editorial list */}
        <div className="flex flex-col" data-id="element-1471">
          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.04
        }} className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 border-b border-white/5 last:border-0" data-id="element-1472">
              <div className="md:col-span-2" data-id="element-1473">
                <span className="font-mono text-xs text-[#1a8fd4]/60" data-id="element-1474">
                  {step.n}
                </span>
              </div>
              <div className="md:col-span-3" data-id="element-1475">
                <h3 className="text-xl font-semibold text-white tracking-tight" data-id="element-1476">
                  {step.title}
                </h3>
              </div>
              <div className="md:col-span-7" data-id="element-1477">
                <p className="text-base text-white/60 leading-relaxed" data-id="element-1478">
                  {step.body}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}